module.exports = __webpack_public_path__ + "78b5eb22716dccfa80b116179efae08b.svg";